var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Datepicker", {
    class: _vm.classString,
    attrs: {
      placeholder: _vm.placeholder,
      format: _vm.format,
      "minimum-view": _vm.minimumView,
      disabled: _vm.disabledDates
    },
    model: {
      value: _vm.model,
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }